<template>
  <div
    v-if="product_item.type === 100"
    :class="['common-inner-card', { 'disabled-card': disabled }]"
  >
    <div class="title-wrap">
      <!-- 课程分类标签 -->
      <div class="inner-tag">
        {{ $$(product_item.extra_info).subject_name }}
      </div>
      <!-- 课程名称 -->
      <div class="inner-title" style="max-width: 100%">
        {{ product_item.name }}
      </div>
    </div>
    <!-- 授课时间 -->
    <div class="inner-desc mg-top-8">
      {{ product_item.desc }}
    </div>
    <div class="inner-desc mg-top-8 flex-center-start">
      <!-- 授课老师 -->
      <span
        :class="{ 'name-gap': tIndex > 0 }"
        v-for="(tItem, tIndex) of teacherInfoList"
        :key="tItem.id"
      >
        {{ tItem.type_name }}：{{ tItem.name }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    teacherInfoList: {
      type: Array,
      default: () => {
        return [];
      },
    },
    product_item: {
      type: Object,
      default: () => {
        return {};
      },
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>
<style lang="less" scoped>
@import "../../../assets/less/layout.less";

.common-inner-card {
  padding: 8px !important;
}
.inner-title {
  font-size: 15px !important;
}
.title-wrap {
  .flex-center-start;
}
.name-gap {
  margin-left: 15px;
}
.inner-tag {
  display: inline-block;
  white-space: nowrap;
  padding: 0 3px;
  border-radius: 4px;
  margin-right: 4px;
  background-color: #e4a970;
  color: #fff;
  font-family: PingFang SC;
  font-size: 11px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
}
</style>
